exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.vvc-tabbar {\n  position: relative;\n  box-sizing: border-box;\n  width: calc(100% - 200px);\n  height: 100%;\n  -webkit-user-select: none;\n  user-select: none;\n}\n.vvc-tabbar .vvc-tabbar-container {\n    position: absolute;\n    bottom: 0px;\n    box-sizing: border-box;\n    height: 30px;\n    padding: 0 10px;\n    white-space: nowrap;\n    transition: all .3s ease-in-out;\n}\n.vvc-tabbar .vvc-ctrl-btn {\n    position: absolute;\n    bottom: 0;\n    z-index: 1;\n    width: 10px;\n    height: 30px;\n    line-height: 30px;\n    color: #ccc;\n    cursor: pointer;\n}\n.vvc-tabbar .vvc-ctrl-btn.btn-left {\n      left: 0;\n}\n.vvc-tabbar .vvc-ctrl-btn.btn-right {\n      right: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-0b05eada!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/tabbar/src/tabbar.vue
// module id = 454
// module chunks = 0